import { FC } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { twMerge } from 'tailwind-merge';
import { GeocodeInputProps } from './geocode-input.types';
import TextField from '../text-field/textField';
import Text from '../text/text';

export const GeocodeInput: FC<GeocodeInputProps> = ({
    label,
    name,
    value,
    placeholder,
    disabled,
    onChange,
    onBlur,
    onSelect,
    onSearchPlace,
    className,
    inputClassName,
    error,
    helperText,
}) => {
    const handleSelect = (address: string) => {
        onSelect && onSelect(address);
        geocodeByAddress(address)
            .then(async (results: google.maps.GeocoderResult[]) => {
                const addressComponents = results[0]?.address_components ?? [];
                const responseLatLng: google.maps.LatLngLiteral = await getLatLng(results[0]);
                onSearchPlace && onSearchPlace({ ...responseLatLng, addressComponents });
            })
            .catch((error: unknown) => console.error('Error geolocalizando', error));
    };

    return (
        <PlacesAutocomplete value={value} onChange={onChange} onSelect={handleSelect} debounce={1000}>
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
                return (
                    <div className={twMerge('relative w-full', className)}>
                        <TextField
                            id={name ?? 'geolocation'}
                            name={name ?? 'geolocation'}
                            rounded="standard"
                            label={label}
                            className={inputClassName}
                            {...getInputProps({
                                placeholder,
                            })}
                            onBlur={onBlur}
                            endButton={
                                loading
                                    ? {
                                          iconName: 'ri-map-pin-time-line',
                                          background: 'transparent',
                                      }
                                    : undefined
                            }
                            required
                            disabled={disabled}
                            error={!!error}
                            errorMessage={error || helperText}
                        />
                        <div className="w-full absolute flex flex-col bg-white rounded z-20 shadow-[0px_3px_10px_0px_rgba(20,115,247,0.12)]">
                            {suggestions.map((option) => (
                                <div {...getSuggestionItemProps(option)}>
                                    <Text
                                        className="cursor-pointer hover:bg-variant-50 p-2"
                                        lineHeight="16"
                                        testId={option.description}
                                    >
                                        {option.description}
                                    </Text>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            }}
        </PlacesAutocomplete>
    );
};

export default GeocodeInput;
